import { useState, useEffect }  from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const url = `${process.env.REACT_APP_API_BASE}/api/utilidades/jurisdiccionales/credenciales/datos/hash`;

function GetData() {
  
  const [ usuario, setUsuario ] = useState(null);
  const navigate = useNavigate();
  const { hash } = useParams();
    
  useEffect(() => {
    fetch(`${url}/${hash}`)
      .then(res => res.json())
      .then(data => {
        const dataMod = {
          ...data, 
          activo: data.estado === 'AGENTE ACTIVO' ? true : false
        }
        setUsuario(dataMod);})
      .catch(() => {
        navigate('/not-found');
      })  
    }, [hash, navigate]);

  return usuario;
}

export { GetData };

